import { _values, removeDBObjectKeys, tsValidateArray, tsValidateBoolean, tsValidateNumber, tsValidateOptionalId, tsValidateRange, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidator_arrayOfUniqueIds } from '@nu-art/ts-common';
import { findingSourceTypesEnum, FindingType_Enumerated, FindingType_Numeric, FindingType_Range, FindingType_Textual, FindingTypes } from './types.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../_core/index.js';
const BaseValidator = {
    ...Validator_EncounterId,
    patientId: tsValidateUniqueId,
    type: tsValidateValue(FindingTypes),
    variableId: (instance, parentObj) => {
        if (!instance)
            return 'no instance provided for validation';
        if (parentObj?.isGeneratedVariable)
            return tsValidateResult(instance, tsValidateString());
        return tsValidateResult(instance, tsValidateUniqueId);
    },
    issuedTimestamp: tsValidateNumber(),
    source: {
        type: tsValidateValue(_values(findingSourceTypesEnum)),
    },
    isGeneratedVariable: tsValidateBoolean(),
    findingDependencies: tsValidator_arrayOfUniqueIds,
    isChiefComplaint: tsValidateBoolean(),
    isPartialCalculation: tsValidateBoolean(false),
    basedOn: tsValidateArray(tsValidateUniqueId),
    isFromNlp: tsValidateBoolean(false),
    showInAdvisor: tsValidateBoolean(false),
    //optionals
    fhirId: tsValidateOptionalId,
    snippetId: tsValidateOptionalId,
    runtimeOrderId: tsValidateOptionalId,
    parentId: tsValidateOptionalId,
    // debug
    _variableName: tsValidateString(undefined, false),
    _valueName: tsValidateString(undefined, false),
};
export const Validator_RuntimeFinding = (instance) => {
    if (!instance)
        return 'runtimeFinding is not provided for validation';
    // remove db object keys for validation, this actually seems like a bug in the infra but needs another look
    const _instance = removeDBObjectKeys(instance);
    if (instance.type === FindingType_Enumerated)
        return tsValidateResult(_instance, {
            ...BaseValidator,
            type: tsValidateValue([FindingType_Enumerated]),
            valueIds: tsValidateArray(tsValidateUniqueId),
            attributes: tsValidateArray({
                type: tsValidateValue([FindingType_Enumerated]),
                variableId: tsValidateUniqueId,
                valueIds: tsValidateArray(tsValidateUniqueId),
                source: {
                    type: tsValidateValue(_values(findingSourceTypesEnum))
                },
                _variableName: tsValidateString(undefined, false),
            }, false),
            valueNames: tsValidateArray(tsValidateString(), false)
        });
    if (instance.type === FindingType_Range) {
        return tsValidateResult(_instance, {
            ...BaseValidator,
            type: tsValidateValue([FindingType_Range]),
            value: tsValidateRange(),
            measurementUnitId: tsValidateUniqueId
        });
    }
    if (instance.type === FindingType_Numeric) {
        return tsValidateResult(_instance, {
            ...BaseValidator,
            type: tsValidateValue([FindingType_Numeric]),
            measurementUnitId: tsValidateUniqueId,
            value: tsValidateNumber(),
            subRangeIds: tsValidateArray(tsValidateUniqueId),
            subRangesNames: tsValidateArray(tsValidateString(), false)
        });
    }
    if (instance.type === FindingType_Textual) {
        return tsValidateResult(_instance, {
            ...BaseValidator,
            type: tsValidateValue([FindingType_Textual]),
            value: tsValidateString()
        });
    }
    return `invalid instance type ${_instance.type}`;
};
export const Validator_GeneratedProps = {};
export const DBDef_RuntimeFinding = {
    modifiablePropsValidator: Validator_RuntimeFinding,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'runtime-findings',
    entityName: 'runtime-finding',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'runtime-finding'
    },
    backend: {
        name: 'runtime-findings'
    }
};
//# sourceMappingURL=db-def.js.map